import React from "react";
import Style from "./InputFileStyle";

export interface InputFileProps extends React.InputHTMLAttributes<HTMLInputElement> {
  id: string;
  text?: string;
  accept: string;
}

const InputFile = React.forwardRef<HTMLInputElement, InputFileProps>((props, ref) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLLabelElement>) => {
    if (e.key === " " || e.key === "Spacebar" || e.key === "Enter") {
      e.preventDefault();
      document.getElementById(props.id as string)?.click();
    }
  };

  return (
    <Style>

      <label tabIndex={0} className="label"
        onKeyDown={handleKeyDown}
        htmlFor={props.id} >
        {props.text || "Upload"}
      </label>
      <input
        {...props}
        ref={ref}
        type="file"
        accept={props.accept}
      />
    </Style >
  );
});

export default InputFile;
